// 爵位详情
export const HY_NOBILITY = 'HY_NOBILITY';

// 保级卡
export const HY_RELEGATION = 'HY_RELEGATION';

// 保级卡
export const HY_NOBILITY_CAR = 'HY_NOBILITY_CAR';

export const HY_NOBILITY_RULE = 'HY_NOBILITY_RULE';

// 提现
export const HY_WITHDRAW_MONEY = 'HY_WITHDRAW_MONEY';

// 提现记录
export const HY_WITHDRAW_MONEY_HISTORY = 'HY_WITHDRAW_MONEY_HISTORY';

// 收入明细
export const HY_INCOME_LIST = 'HY_INCOME_LIST';

// 主播推荐图
export const HY_ANCHORS_RECOMMEND_PIC = 'HY_ANCHORS_RECOMMEND_PIC';
export const HY_ANCHORS_RECOMMEND_PIC_CLIP = 'HY_ANCHORS_RECOMMEND_PIC_CLIP';

export const HY_LUCKYDRAW = 'HY_LUCKYDRAW';
// 房间模式说明页
export const HY_ROOM_MODE_EXPLAIN = 'HY_ROOM_MODE_EXPLAIN';
// 考核审核
export const HY_RECOMMEND_APPRAISAL = 'HY_RECOMMEND_APPRAISAL';
// 举报理由
export const HY_COMPLAINT = 'HY_COMPLAINT';
